import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
const steps = [{
  num: '01',
  title: "Tell us what you're imagining",
  body: "A photo, a sketch, a single word, or just a feeling. There's no wrong way to begin."
}, {
  num: '02',
  title: 'Sit down for a quiet chat',
  body: "Honest guidance on what's possible, what's worth spending more on, and what isn't."
}, {
  num: '03',
  title: 'Review designs & a firm written quote',
  body: 'Multiple approaches, clear pricing, no surprises later.'
}, {
  num: '04',
  title: 'See a CAD model and 3D resin proof',
  body: "Where suitable, you'll hold and try your piece before it's ever made in metal."
}, {
  num: '05',
  title: 'Crafted on our Ardross bench',
  body: "By James or a jeweller he's trained — start to finish, never outsourced."
}, {
  num: '06',
  title: 'Final checks, presentation & lifetime care',
  body: 'Polished, photographed, presented in a proposal-ready box. And cared for, forever.'
}];
export function Process() {
  return <section className="section-padding bg-background" data-id="element-520">
      <div className="container-custom" data-id="element-521">
        <div className="max-w-3xl mb-14" data-id="element-522">
          <span className="eyebrow" data-id="element-523">How it works</span>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium leading-[1.1] mb-6 text-balance" data-id="element-524">
            From first quiet question to finished piece —{' '}
            <span className="italic text-gold-dark" data-id="element-525">a calm, clear path.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-gold/15 border border-gold/15 mb-12" data-id="element-526">
          {steps.map((step, index) => <motion.article key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.06
        }} className="bg-background p-8 md:p-9" data-id="element-527">
              <span className="signature text-5xl md:text-6xl text-gold-dark leading-none block mb-4" data-id="element-528">
                {step.num}
              </span>
              <h3 className="font-serif text-xl text-primary mb-2 leading-snug" data-id="element-529">
                {step.title}
              </h3>
              <p className="text-sm text-secondary leading-relaxed text-pretty" data-id="element-530">
                {step.body}
              </p>
            </motion.article>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-primary text-white p-8 md:p-12 relative overflow-hidden" data-id="element-531">
          <div className="absolute inset-0 opacity-[0.05]" style={{
          backgroundImage: 'radial-gradient(var(--color-gold-light) 1px, transparent 1px)',
          backgroundSize: '24px 24px'
        }} data-id="element-532" />
          <div className="relative grid lg:grid-cols-[auto_1fr_auto] gap-6 lg:gap-10 items-center" data-id="element-533">
            <ShieldCheckIcon className="w-12 h-12 text-gold-light shrink-0" strokeWidth={1.25} data-id="element-534" />
            <div data-id="element-535">
              <p className="eyebrow-light mb-2" data-id="element-536">The Sinclairs Promise</p>
              <p className="font-serif text-xl md:text-2xl text-white leading-snug mb-2" data-id="element-537">
                You'll never be surprised by a price, a timeline, or a finished
                design.
              </p>
              <p className="text-sm text-white/70 leading-relaxed" data-id="element-538">
                Firm written quote. Your design approval before manufacture.
                Lifetime cleaning and inspection. In writing. Always.
              </p>
            </div>
            <a href="#consultation" className="btn-gold shrink-0" data-id="element-539">
              Start a conversation
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}